import React from "react";

function RepostGrayIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
    >
      <g
        id="Group_27859"
        data-name="Group 27859"
        transform="translate(14595.785 14665)"
      >
        <g
          id="Rectangle_1959"
          data-name="Rectangle 1959"
          transform="translate(-14595.785 -14665)"
          fill="#fff"
          stroke="#596970"
          strokeWidth="1"
        >
          <rect width="56" height="56" rx="28" stroke="none" />
          <rect x="0.5" y="0.5" width="55" height="55" rx="27.5" fill="none" />
        </g>
        <g id="Group_27858" data-name="Group 27858" transform="translate(-63)">
          <rect
            id="Rectangle_11971"
            data-name="Rectangle 11971"
            width="35"
            height="33"
            transform="translate(-14522 -14653)"
            fill="#596970"
            opacity="0"
          />
          <g
            id="Group_26869"
            data-name="Group 26869"
            transform="translate(-26782.271 -12403)"
          >
            <path
              id="Path_18878"
              data-name="Path 18878"
              d="M5,9.544v8.235H6.823v-6.4H16.1l-3.6,3.614,1.289,1.294,5.8-5.823-5.8-5.823L12.5,5.93l3.6,3.614Z"
              transform="translate(12266.271 -2250.636)"
              fill="#596970"
            />
            <path
              id="Path_18882"
              data-name="Path 18882"
              d="M19.586,12.871V4.636H17.763v6.4H8.49l3.6-3.614L10.8,6.133,5,11.956l5.8,5.823,1.289-1.294-3.6-3.614Z"
              transform="translate(12266.271 -2238.779)"
              fill="#596970"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default RepostGrayIcon;
